import { GoogleLogin } from '@react-oauth/google'
import { useRef } from 'react'
import { useContainerDimensions } from './hooks/useContainerDimensions'

const HIDE_GOOGLE_LOGIN = process.env.REACT_APP_HIDE_GOOGLE_LOGIN

export default function GoogleLoginBtn({ onSuccess, onError }) {
    const googleWrapperRef = useRef(null)
    const { width: googleWidth } = useContainerDimensions(googleWrapperRef)

    if (HIDE_GOOGLE_LOGIN === 'true') {
        return
    }

    return (
        <div className={'google-login-wrapper'} ref={googleWrapperRef}>
            <GoogleLogin
                size={'large'}
                text={'continue_with'}
                type={'standard'}
                theme={'outline'}
                width={304}
                logo_alignment={'center'}
                onSuccess={(credentials) => onSuccess(credentials)}
                onError={() => onError('ERROR')}
            />
        </div>
    )
}
